import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "menu-item" }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_6 = {
  key: 1,
  class: "menu-bullet"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "menu-title" }
const _hoisted_10 = { class: "menu-link" }
const _hoisted_11 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_13 = {
  key: 1,
  class: "menu-bullet"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "menu-title" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SubMenu = _resolveComponent("SubMenu", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, j) => {
    return (_openBlock(), _createElementBlock("div", { key: j }, [
      (!item.children && !(item.meta && item.meta.hidden && item.meta.hidden === true) && _ctx.hasPermission(item))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: item.path
              }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    (item.meta && (item.meta.svgIcon || item.meta.fontIcon))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          (_ctx.asideMenuIcons === 'font')
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass([item.meta.fontIcon, "bi fs-3"])
                              }, null, 2))
                            : (_ctx.asideMenuIcons === 'svg')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                  _createVNode(_component_inline_svg, {
                                    src: item.meta.svgIcon
                                  }, null, 8, ["src"])
                                ]))
                              : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate(item.name)), 1)
                  ], 10, _hoisted_3)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        : _createCommentVNode("", true),
      (item.children && !(item.meta && item.meta.hidden && item.meta.hidden === true) && _ctx.hasPermission(item))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([{ show: _ctx.hasActiveChildren(item.path) }, "menu-item menu-accordion"]),
            "data-kt-menu-sub": "accordion",
            "data-kt-menu-trigger": "click"
          }, [
            _createElementVNode("span", _hoisted_10, [
              (item.meta && (item.meta.svgIcon || item.meta.fontIcon))
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    (_ctx.asideMenuIcons === 'font')
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass([item.meta.fontIcon, "bi fs-3"])
                        }, null, 2))
                      : (_ctx.asideMenuIcons === 'svg')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _createVNode(_component_inline_svg, {
                              src: item.meta.svgIcon
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate(item.name)), 1),
              _hoisted_17
            ]),
            (item.children)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item.path) }, "menu-sub menu-sub-accordion"])
                }, [
                  _createVNode(_component_SubMenu, {
                    menu: item.children
                  }, null, 8, ["menu"])
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}